import { useQuery } from "@tanstack/react-query";
import RoleService from "../services/Role/RoleService";

export const useRoles = () => {
    return useQuery({
        queryKey: ["roles"],
        queryFn: () => RoleService.getRoles().then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
        placeholderData: (prevData) => prevData
    });
};